import { motion } from "framer-motion";

export default function KarmaTitle({
  timeRemaining,
}: {
  timeRemaining: number;
}) {
  return (
    <motion.div
      className="text-center mb-2"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <motion.h1
        className="text-2xl font-black uppercase tracking-wide flex items-center gap-2"
        style={{
          background:
            "linear-gradient(135deg, hsl(200, 100%, 70%) 0%, hsl(220, 100%, 60%) 50%, hsl(260, 80%, 55%) 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
          filter:
            "drop-shadow(0 0 20px hsl(220, 100%, 60%)) drop-shadow(0 0 40px hsl(260, 80%, 50%))",
        }}
      >
        3 winners rolling in{" "}
        <motion.span
          className="inline-block tabular-nums mb-1"
          animate={{ scale: [1, 1.1, 1] }}
          transition={{ duration: 0.5, repeat: Infinity }}
          style={{
            background:
              "linear-gradient(135deg, hsl(180, 100%, 70%) 0%, hsl(200, 100%, 65%) 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          {timeRemaining}s
        </motion.span>
      </motion.h1>
    </motion.div>
  );
}
